import React, { useState } from 'react';
import {
    IconContainer,
    Learn3XLink,
    LoyaltyProgressSubContainer,
    ProgressBarCenter,
    StyledCard,
} from './CircularProgressBar.styled';
import { RewardProgressBarProps } from './types';
import RadialSeparators from './RadialSeparator';
import SubscriptionVoucherIcon from '../Icons/SubscriptionVoucherIcon';
import SubscriptionVoucherIconGrey from '../Icons/SubscriptionVoucherIconGrey';
import { FaExclamationTriangle } from 'react-icons/fa';
import { NsTypography } from '@nuskin/foundation-ui-components';
import { CircularProgressbarWithChildren, buildStyles } from 'react-circular-progressbar';
import { RewardProgressTotalButtonWithIcon, RewardProgressTotalContainer } from './CircularProgressBar.styled';
import Info from '../Icons/Info';
import { Tooltip, IconButton } from '@mui/material';
import { replacePlaceholders } from '../Utils/helper';

const SubscriptionRewardMobile = (props: RewardProgressBarProps) => {
    const [open, setOpen] = useState(false);
    const handleTooltipToggle = () => {
        setOpen(!open);
    };
    const {
        handleOpenSubscriptionRewardPopup = () => {},
        notQualifyForRewardThisMonth = false,
        value = 0,
        voucherValue = 0,
        amountShow,
        maxMonths = 0,
        translationConfig = {
            voucherTargetAmount: '',
            monthsComplete: '',
            voucherEarned: '',
            learnMore: '',
            learn3xMore: '',
            callToAction: '',
            notQualify: '',
            approximateMonthly: '',
            approximateTotal: '',
            currentlyTrack: '',
            loyaltyLogoBlack: '',
            estimateDisclaimer: '',
        },
        learnMoreConfig = {
            tagLine: '',
            cardOneDescription: '',
            cardOneVoucherAmount: '',
            cardTwoDescription: '',
            cardTwoVoucherAmount: '',
            header: '',
            loyaltyLogoWhite: '',
            loyaltyBanner: '',
            learnMore: '',
        },
        storeConfig = {
            tiers: [
                {
                    consecutive_months: '',
                    min_spend: '',
                    max_spend: '',
                    promo_code: '',
                },
                {
                    consecutive_months: '',
                    min_spend: '',
                    promo_code: '',
                },
            ],
        },
        currencyAbbreviate = false,
        currencyFormat = () => {},
    } = props;

    let popupText = '';
    const minVoucher = 50;
    const maxVoucher = 150;
    if (voucherValue === minVoucher && !notQualifyForRewardThisMonth) {
        popupText = translationConfig.learn3xMore;
    } else if (voucherValue === maxVoucher || notQualifyForRewardThisMonth) {
        popupText = learnMoreConfig.learnMore;
    } else if (voucherValue === null || voucherValue === undefined) {
        popupText = translationConfig.learnMore;
    }

    const monthsCompleteText = replacePlaceholders(translationConfig.monthsComplete, {
        completed_months: value,
        total_months: maxMonths,
    });
    const voucherEarned = voucherValue
        ? currencyFormat(voucherValue, true, currencyAbbreviate)
        : currencyFormat(0, true, currencyAbbreviate);
    const voucherEarnedText = translationConfig.voucherEarned.replace(
        '%currency_symbol%%currency_amount%',
        `${voucherEarned}`,
    );
    const currentlyTrackText = translationConfig.currentlyTrack.replace(
        '%currency_symbol%%currency_amount%',
        `${voucherEarned}`,
    );
    const approximateTotalText = replacePlaceholders(translationConfig.approximateTotal, {
        currency_symbol: '',
        projected_month_spend: '',
    });
    const minAmount = parseFloat(String(storeConfig?.tiers?.[0]?.min_spend)) || 0;
    const minAmountShow = currencyFormat(minAmount, true, currencyAbbreviate);
    const callToActionText = translationConfig.callToAction.replace(
        '%currency_symbol%%current_spend_target%',
        `${minAmountShow}`,
    );
    const approximateMonthlyText = replacePlaceholders(translationConfig.approximateMonthly, {
        currency_symbol: '',
        estimated_running_subscription_spend: '',
    });
    const voucherTargetAmount = replacePlaceholders(translationConfig.voucherTargetAmount, {
        currency_symbol: '',
        voucher_amount: '',
    });
    const amountShowText = currencyFormat(amountShow ?? 0, false, false);

    return (
        <LoyaltyProgressSubContainer>
            <StyledCard>
                <img className="reward-logo" src={translationConfig.loyaltyLogoBlack} alt="Rewards Logo" />
            </StyledCard>
            <div className="reward-progress">
                <CircularProgressbarWithChildren
                    value={(value / maxMonths) * 100}
                    strokeWidth={12}
                    background
                    styles={buildStyles({
                        rotation: 0.5,
                        strokeLinecap: 'butt',
                        backgroundColor:
                            value === maxMonths && !notQualifyForRewardThisMonth
                                ? 'rgb(195 240 194)'
                                : notQualifyForRewardThisMonth
                                  ? '#fff'
                                  : '#fff',
                        pathColor: '#6BC56A',
                        trailColor: '#E0E0E0',
                    })}
                >
                    <RadialSeparators count={maxMonths} />
                    {value === maxMonths && !notQualifyForRewardThisMonth ? (
                        <SubscriptionVoucherIcon />
                    ) : notQualifyForRewardThisMonth ? (
                        <IconContainer>
                            <FaExclamationTriangle className="outline-exclamation-icon" color="#91ACC8" />
                        </IconContainer>
                    ) : voucherValue != null || voucherValue != undefined ? (
                        <ProgressBarCenter>
                            <NsTypography
                                component="div"
                                className="center-value-progress-bar-price"
                                variant="title-l"
                                weight="bold"
                            >{`${voucherEarned}`}</NsTypography>
                            <NsTypography
                                variant="label-s"
                                weight="bold"
                                component="div"
                                className="center-value-progress-bar-voucher"
                            >
                                {voucherTargetAmount}
                            </NsTypography>
                        </ProgressBarCenter>
                    ) : (
                        <ProgressBarCenter>
                            <SubscriptionVoucherIconGrey />
                        </ProgressBarCenter>
                    )}
                </CircularProgressbarWithChildren>
            </div>
            <StyledCard>
                {value === maxMonths && amountShow !== undefined && amountShow > minAmount ? (
                    <div className="info-item">{voucherEarnedText}</div>
                ) : (
                    <div className="info-item">{monthsCompleteText}</div>
                )}
            </StyledCard>
            <RewardProgressTotalContainer>
                {value === maxMonths ? (
                    ''
                ) : notQualifyForRewardThisMonth ? (
                    <NsTypography
                        variant="body-s"
                        weight="normal"
                        className="reward-subtitle"
                        colorOverride="#252525"
                        component="div"
                    >
                        {approximateTotalText}{' '}
                        <NsTypography component="span" className="button-price" variant="body-s" weight="bold">
                            {`${amountShowText}`}
                        </NsTypography>
                    </NsTypography>
                ) : voucherValue != null || voucherValue != undefined ? (
                    <NsTypography variant="body-s" weight="bold" className="reward-subtitle" colorOverride="#252525">
                        {currentlyTrackText}
                    </NsTypography>
                ) : (
                    <NsTypography variant="body-s" weight="bold" className="reward-subtitle" colorOverride="#252525">
                        {callToActionText}
                    </NsTypography>
                )}
                <RewardProgressTotalButtonWithIcon>
                    {notQualifyForRewardThisMonth ? (
                        <>
                            <IconContainer>
                                <FaExclamationTriangle className="loyalty-warning-icon" color="#4A6987" />
                            </IconContainer>
                            <NsTypography
                                variant="body-s"
                                weight="normal"
                                className="reward-subtitle"
                                colorOverride="#293A4A"
                                noSpacing
                            >
                                {translationConfig.notQualify}
                            </NsTypography>
                        </>
                    ) : (
                        <>
                            <NsTypography
                                variant="body-s"
                                weight="normal"
                                colorOverride="#252525"
                                className="reward-subtitle"
                                component="span"
                                noSpacing
                            >
                                {approximateMonthlyText}{' '}
                            </NsTypography>
                            &nbsp;
                            <NsTypography weight="bold" className="button-price" variant="body-s" component="span">
                                {`${amountShowText}`}
                            </NsTypography>
                            <IconContainer>
                                <Tooltip
                                    slotProps={{
                                        tooltip: {
                                            sx: {
                                                color: '#FFFFFF',
                                                backgroundColor: '#252525',
                                                fontFamily: 'Inter',
                                                fontWeight: 400,
                                                fontSize: '14px',
                                                lineHeight: '20px',
                                                '& .MuiTooltip-arrow': {
                                                    color: '#252525',
                                                },
                                            },
                                        },
                                    }}
                                    title={translationConfig.estimateDisclaimer}
                                    arrow
                                    placement="top"
                                    open={open}
                                    onClose={() => setOpen(false)}
                                >
                                    <span className="info-icon">
                                        <IconButton onClick={handleTooltipToggle}>
                                            <Info />
                                        </IconButton>
                                    </span>
                                </Tooltip>
                            </IconContainer>
                        </>
                    )}
                </RewardProgressTotalButtonWithIcon>
            </RewardProgressTotalContainer>
            <StyledCard>
                <Learn3XLink onClick={handleOpenSubscriptionRewardPopup}>
                    <u>{popupText}</u>
                </Learn3XLink>
            </StyledCard>
        </LoyaltyProgressSubContainer>
    );
};

export default SubscriptionRewardMobile;
export { SubscriptionRewardMobile };
